
import { CanMatchFn, Route, UrlSegment, Router } from '@angular/router';
import { inject } from '@angular/core';

export const urlValidatorGuard: CanMatchFn = (
    route: Route,
    segments: UrlSegment[]
) => {
    const router = inject(Router);

    const fullPath = '/' + segments.map(s => decodeURIComponent(s.path)).join('/');

    const validPatterns = [
        // صفحه اصلی
        /^\/$/,

        // international-hotels
        /^\/international-hotels\/?$/,

        // صفحات ثابت persian
        /^\/persian\/policy\/?$/,
        /^\/persian\/privacypolicy\/?$/,
        /^\/persian\/best-price-guarantee\/?$/,

        // deals/:deal
        /^\/deals\/[^/]+\/?$/,

        // residency
        /^\/residency\/?$/,

        // مسیرهایی که residencyMatcher پوشش میده (فرض: /residency/group/:name)
        /^\/residency\/group\/[^/]+\/?$/,

        // city-hotels و city-hotels/hotel
        /^\/[a-zA-Z0-9-%آ-ی]+-hotels\/?$/,              // /tehran-hotels
        /^\/[a-zA-Z0-9-%آ-ی]+-hotels\/[^/]+\/?$/,       // /tehran-hotels/هتل-استقلال

        // ecolodge/type or city, ecolodge/type/map
        /^\/ecolodge\/[^/]+\/?$/,
        /^\/ecolodge\/[^/]+\/map\/?$/,
        /^\/ecolodge\/[\u0600-\u06FFa-zA-Z0-9%\-–—ـ_]+\/[\u0600-\u06FFa-zA-Z0-9%\-–—ـ_]+\/?$/,

        // city/map
        /^\/[a-zA-Z0-9-%آ-ی]+\/map\/?$/,

        // city/star5 یا city/rec
        /^\/[a-zA-Z0-9-%آ-ی]+\/(star\d+|[a-zA-Z0-9-]+-rec)\/?$/,

        // /tur/istanbul
        /^\/[a-zA-Z]{3}\/?$/,                        // /tur
        /^\/[a-zA-Zآ-ی0-9%]{3}\/[^/]+\/?$/,          // /tur/istanbul
        /^\/[a-zA-Z0-9آ-ی%]{3}\/[^/]+\/[^/]+\/?(?:\?.*)?$/,   // /tur/istanbul/hotel-name

        // /country/city/resident (فرض: داینامیک مثل /iran/tehran/resident)
        /^\/[a-zA-Z0-9-%آ-ی]+\/[^/]+\/resident\/?$/,

        // مسیرهای فارسی با هتل (اگر نیاز هست)
        /^\/[a-zA-Z0-9-]+-hotels\/[\u0600-\u06FFa-zA-Z0-9-%]+\/?$/,

        // مسیرهای با اسامی طولانی‌تر (با space و dash)
        /^\/[a-zA-Z0-9-]+-hotels\/[\u0600-\u06FFa-zA-Z0-9\-–—ـ_%\s]+\/?$/,

        // city/hotel/نظرات یا tehran-hotels/هتل-استقلال/نظرات
        /^\/[a-zA-Z0-9-%آ-ی]+\/[^/]+\/نظرات\/?$/,               // /tehran/hotel/نظرات
        /^\/[a-zA-Z0-9-]+-hotels\/[\u0600-\u06FFa-zA-Z0-9-%]+\/نظرات\/?$/ // /tehran-hotels/هتل-استقلال/نظرات
    ];


    const isValid = validPatterns.some(p => p.test(fullPath));
    if (!isValid) {
        router.navigateByUrl('/notfound');
        return false;
    }

    return true;
};
